import { API, graphqlOperation } from 'aws-amplify';
import {
  CREATE_UNIT_MUTATION,
  UPDATE_UNIT_MUTATION,
  DELETE_UNIT_MUTATION,
} from './graphql/mutations';
import { CurriculumUnit } from '@/models'; // Define this in a common location if needed

export class CurriculumService<T = CurriculumUnit> {

  async create(unit: T): Promise<T> {
    return unit;
    try {
      const response: any = await API.graphql(graphqlOperation(CREATE_UNIT_MUTATION, { input: unit }));
      const createdUnit = response.data.createUnit;
      return createdUnit;
    } catch (error) {
      throw error;
    }
  }

  async update(unit: T): Promise<T> {
    return unit;
    try {
      const response: any = await API.graphql(graphqlOperation(UPDATE_UNIT_MUTATION, { input: unit }));
      const updatedUnit = response.data.updateUnit;
      return updatedUnit;
    } catch (error) {
      throw error;
    }
  }

  async delete(unitId: string): Promise<boolean> {
    return true;
    try {
      await API.graphql(graphqlOperation(DELETE_UNIT_MUTATION, { input: { id: unitId } }));
      return !!unitId;
    } catch (error) {
      throw error;
    }
  }
}

export default new CurriculumService();